import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import RouterUtils from '../../shared/routing/RouterUtils';
import * as outsourceActions from '../actions/outsourceActions';
import * as exportOutsourceDocsActions from '../actions/exportOutsourceDocsActions';
import ExportOutsourceDocsCardConfirm from '../components/export/ExportOutsourceDocsCardConfirm';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class ExportOutsourceDocsConfirmScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { outsource, location } = this.props;

        if ( !outsource ) {
            window.history.back();
        } else {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
                url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsource.id }),
                description: outsource.name,
            });

            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT.id,
                url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT, { id: outsource.id }),
                description: I18nUtils.tr('TR_EXPORTAR'),
            });

            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM.id,
                url: location.pathname,
                description: I18nUtils.tr('TR_CONFIRMACION'),
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_CONFIRMAR_EXPORTACIÓN_DE_DOCUMENTOS_DE_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                {
                    this.props.outsource ? (
                        <ExportOutsourceDocsCardConfirm/>
                    ) : null
                }
            </PsPage>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        outsource: state.exportOutsourceDocs.outsource,
    };
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
    exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsConfirmScreen);



// WEBPACK FOOTER //
// ./src/app/outsource/screens/ExportOutsourceDocsConfirmScreen.js